export default function ClinicComparisonPage() {
  return (
    <section>
      <div className="page-header">
        <h1>Compare clinics</h1>
        <p className="page-header__sub">Side-by-side zone clinics</p>
      </div>
      <p className="scaffold-note">Side-by-side clinic comparison for your zone. Detailed comparison views are available in the next pilot phase.</p>
    </section>
  );
}
